<div *ngIf="autorizado; else noAutorizado">
  <div class="unidad-config-classroom">
    <form *ngIf="notSaving$ | async; else saving" [formGroup]="classroomSelectForm" style="width: 80%; margin-right: auto;">
      <mat-form-field class="full-width">
        <mat-label>Clases de Classroom disponibles</mat-label>
        <mat-select formControlName="classroomSelect" [disabled]="!editable" [value]="actual">
          <mat-option *ngFor="let class of courses" [value]="class.id">
            {{class.name  + (class.section ?'(' + class.section + ')' : '')}}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="classroomSelectForm.get('classroomSelect').invalid && classroomSelectForm.get('classroomSelect').touched">
          Campo requerido
        </mat-error>
      </mat-form-field>
    </form>
    <ng-template #saving>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
    <a matTooltip="Ir al classroom" *ngIf="materia.course"
      [href]="materia.course ? materia.course.alternateLink : ''" target="_blank" class="misc-icons">
      <mat-icon>launch</mat-icon>
    </a>
    <button matToolTip="Desenlazar" *ngIf="materia.course" (click)="desEnlazar()" mat-icon-button color="primary" class="misc-icons">
      <mat-icon>link_off</mat-icon>
    </button>
  </div>
</div>
<ng-template #noAutorizado>
  <div class="unidad-config-classroom">
    <mat-select
      matTooltip="Usted no puede hacer acciones sobre este Classroom, por favor comuniquese con el usuario que enlazo la clase."
      matTooltipPosition="before"
      disabled="true" value="0">
      <mat-option value="0">
        Classroom de otro usuario
      </mat-option>
    </mat-select>
    <button disabled="true" mat-icon-button color="primary">
      <mat-icon>launch</mat-icon>
    </button>
    <button disabled="true" mat-icon-button color="primary">
      <mat-icon>link_off</mat-icon>
    </button>
  </div>
</ng-template>
